<template>
<section class="u-description u-description__container" v-if="list">
    <div class="u-description-title">Описание</div>
    <ul class="u-description-list" v-html="list"></ul>
</section>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'UserProfile',
    props: {},

    data() {
        return {};
    },
    watch: {
        // Здесь можно добавить наблюдатели
    },

    beforeCreate() {
        // Вызывается до создания экземпляра компонента
    },

    created() {
        // Вызывается после создания экземпляра компонента
    },

    beforeMount() {
        // Вызывается перед монтированием компонента
    },

    mounted() {
        // Вызывается после монтирования компонента
    },

    computed: {
        // Здесь можно добавить вычисляемые свойства
        ...mapState({
            list: state => state.data.props.description.value,
        })
    },
    methods: {
        // Здесь можно добавить методы
    }
};
</script>